export default __webpack_public_path__ + "static/media/badge.cdef2b94.png";